/**
 * ntc-megamenu.js — la tendina che segue il mouse.
 *
 * ⭐ IL MOVIMENTO (copiato da lovable.dev, misurato dal browser): la scheda ha posizione e
 * misura scritte QUI come stile in linea (`left`, `width`, `height`) e la CSS le anima.
 * Cambiando voce non si chiude: scivola sotto alla voce nuova e cambia misura, mentre il
 * contenuto vecchio esce di lato e quello nuovo entra dall'altro. La direzione e' quella
 * della voce nuova rispetto alla vecchia nella barra.
 *
 * ⚠️ La misura si legge dal contenuto NUOVO prima di animare: e' per questo che i
 * contenuti sono `position: absolute` con larghezza «quanto serve» — si possono misurare
 * senza che la scheda ci si adatti da sola.
 * ⚠️ Col mouse si apre passandoci sopra, ma con un ritardo: senza, basta attraversare la
 * barra per andare al carrello e la tendina sbatte aperta in faccia.
 * ⚠️ Sul telefono NON esiste il passaggio del mouse: li' si apre solo col tocco, e resta
 * il foglio a due passi (reparti → categorie), senza animazioni di scorrimento.
 * ⚠️ Niente stato sul server e niente memoria: il menu e' solo navigazione.
 */
( function () {
  'use strict';

  var STRETTO = '(max-width: 1099px)';
  var RITARDO_APRE = 120;
  var RITARDO_CHIUDE = 200;
  var DURATA_CAMBIO = 300;   // ⚠️ un filo piu' della transizione CSS (270ms)
  var DURATA_CHIUSURA = 180;
  var MARGINE = 16;          // la scheda non tocca mai i bordi dello schermo
  var RIENTRO = 10;          // la scheda parte un po' a sinistra della voce, come il testo della voce

  function avvia( radice ) {
    if ( radice.dataset.ntcPronto === '1' ) { return; }
    radice.dataset.ntcPronto = '1';

    var pannello = radice.querySelector( '[data-mm="pannello"]' );
    var velo     = radice.querySelector( '[data-mm="velo"]' );
    var voci     = Array.prototype.slice.call( radice.querySelectorAll( '[data-mm="voce"]' ) );
    var reparti  = Array.prototype.slice.call( radice.querySelectorAll( '[data-mm="reparto"]' ) );
    var pane     = Array.prototype.slice.call( radice.querySelectorAll( '[data-mm="pane"]' ) );
    var tutte    = radice.querySelector( '[data-mm="tutte"]' );
    var chiudiBt = Array.prototype.slice.call( radice.querySelectorAll( '[data-mm="chiudi"]' ) );
    var indietro = radice.querySelector( '[data-mm="indietro"]' );
    var titoloM  = radice.querySelector( '[data-mm="titolo-mobile"]' );
    if ( ! pannello || pane.length === 0 ) { return; }

    var ordine = pane.map( function ( p ) { return p.getAttribute( 'data-gruppo' ); } );
    var parolaPezzi = radice.getAttribute( 'data-parola-pezzi' ) || '';

    var aperto = false;
    var corrente = null;
    var tApre = null;
    var tChiude = null;
    var tEsce = null;
    var tCambio = null;

    function stretto() {
      return window.matchMedia( STRETTO ).matches;
    }

    function ridotta() {
      return window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
    }

    function alPassaggio() {
      return radice.getAttribute( 'data-apri-al-passaggio' ) === 'true' && ! stretto();
    }

    // ⛔ NON `toLocaleString('it-IT')`: per l'italiano il browser NON separa le migliaia
    //    sotto ai cinque numeri («3279» ma «11.986», regola CLDR). Qui il punto c'e' sempre.
    function numero( n ) {
      n = parseInt( n, 10 );
      if ( isNaN( n ) ) { return ''; }
      return String( n ).replace( /\B(?=(\d{3})+(?!\d))/g, '.' );
    }

    // ⚠️ I numeri arrivano dal Liquid nudi («5240»): qui diventano «5.240» — anche dentro
    //    alle frasi gia' composte («12 categorie · 5240 ricambi»).
    function formattaNumeri( s ) {
      return String( s || '' ).replace( /\d{4,}/g, function ( m ) { return numero( m ) || m; } );
    }
    Array.prototype.forEach.call( radice.querySelectorAll( '[data-numero]' ), function ( el ) {
      var s = numero( el.getAttribute( 'data-numero' ) );
      if ( s ) { el.textContent = s; }
    } );

    function paneDi( id ) {
      for ( var i = 0; i < pane.length; i++ ) {
        if ( pane[ i ].getAttribute( 'data-gruppo' ) === id ) { return pane[ i ]; }
      }
      return null;
    }

    function voceDi( id ) {
      for ( var i = 0; i < voci.length; i++ ) {
        if ( voci[ i ].getAttribute( 'data-gruppo' ) === id ) { return voci[ i ]; }
      }
      return null;
    }

    /**
     * Sul telefono il pannello ha DUE passi: l'elenco dei reparti, e dentro le categorie.
     */
    function passo( n ) {
      if ( ! stretto() ) {
        pannello.removeAttribute( 'data-livello' );
        if ( indietro ) { indietro.hidden = true; }
        return;
      }
      pannello.setAttribute( 'data-livello', String( n ) );
      if ( indietro ) { indietro.hidden = n !== 2; }
      if ( titoloM ) {
        var b = radice.querySelector( '[data-mm="reparto"][aria-selected="true"] strong' );
        titoloM.textContent = n === 2 && b ? b.textContent
          : ( tutte ? tutte.textContent.trim() : '' );
      }
    }

    function segna( id ) {
      reparti.forEach( function ( r ) {
        r.setAttribute( 'aria-selected', r.getAttribute( 'data-gruppo' ) === id ? 'true' : 'false' );
      } );
      voci.forEach( function ( v ) {
        v.setAttribute( 'aria-expanded', aperto && v.getAttribute( 'data-gruppo' ) === id ? 'true' : 'false' );
      } );
    }

    /**
     * Mette la scheda sotto alla voce e le da' la misura del contenuto.
     *
     * ⚠️ Si misura il contenuto (`offsetWidth/Height`), non la scheda: la scheda ha la
     * misura VECCHIA finche' non finisce l'animazione. Il contenuto e' assoluto e largo
     * quanto gli serve, quindi la sua misura e' quella giusta da subito.
     * ⚠️ Se la voce sta a destra e la scheda non ci sta, si sposta a sinistra quanto basta:
     * mai fuori dallo schermo.
     */
    function posiziona( id ) {
      if ( stretto() ) {
        pannello.style.left = '';
        pannello.style.width = '';
        pannello.style.height = '';
        return;
      }
      var p = paneDi( id );
      var v = voceDi( id );
      if ( ! p ) { return; }
      var w = p.offsetWidth;
      var h = p.offsetHeight;
      var rr = radice.getBoundingClientRect();
      var x = v ? v.getBoundingClientRect().left - rr.left - RIENTRO : MARGINE;
      var massimo = rr.width - w - MARGINE;
      if ( x > massimo ) { x = massimo; }
      if ( x < MARGINE ) { x = MARGINE; }
      pannello.style.left = Math.round( x ) + 'px';
      pannello.style.width = w + 'px';
      pannello.style.height = h + 'px';
    }

    /* ── il riquadro grande che «diventa» la categoria su cui si passa ─────────────────── */

    function impostaAnteprima( a, nome, conto, foto, url, subito ) {
      if ( ! a ) { return; }
      var chiave = url + '|' + nome;
      if ( a.getAttribute( 'data-corrente' ) === chiave ) { return; }
      a.setAttribute( 'data-corrente', chiave );
      var img = a.querySelector( '[data-mm="anteprima-foto"]' );
      var n = a.querySelector( '[data-mm="anteprima-nome"]' );
      var c = a.querySelector( '[data-mm="anteprima-conto"]' );
      clearTimeout( a.__t );
      clearTimeout( a.__t2 );

      function applica() {
        if ( n ) { n.textContent = nome; }
        if ( c ) { c.textContent = conto; }
        if ( url ) { a.setAttribute( 'href', url ); }
        if ( img ) {
          if ( foto ) {
            img.hidden = false;
            if ( img.getAttribute( 'src' ) !== foto ) {
              img.onload = function () { a.removeAttribute( 'data-cambia' ); };
              img.src = foto;
              // ⚠️ Se la foto tarda (o non arriva), il riquadro non resta invisibile.
              a.__t2 = setTimeout( function () { a.removeAttribute( 'data-cambia' ); }, 600 );
              return;
            }
          } else {
            img.hidden = true;
            img.removeAttribute( 'src' );
          }
        }
        a.removeAttribute( 'data-cambia' );
      }

      if ( subito || ridotta() ) { applica(); return; }
      a.setAttribute( 'data-cambia', '1' );
      a.__t = setTimeout( applica, 140 );
    }

    function ripristinaAnteprima( p ) {
      var a = p.querySelector( '[data-mm="anteprima"]' );
      if ( ! a ) { return; }
      impostaAnteprima( a, a.getAttribute( 'data-nome-base' ), formattaNumeri( a.getAttribute( 'data-conto-base' ) ),
        a.getAttribute( 'data-foto-base' ), a.getAttribute( 'data-url-base' ), true );
    }

    // ⚠️ Le foto grandi delle categorie si precaricano la prima volta che il reparto si
    //    apre, cosi' il cambio in dissolvenza non aspetta la rete.
    function precarica( p ) {
      if ( p.dataset.precaricato === '1' ) { return; }
      p.dataset.precaricato = '1';
      setTimeout( function () {
        Array.prototype.forEach.call( p.querySelectorAll( '[data-mm="riga"][data-foto]' ), function ( r ) {
          var im = new Image();
          im.src = r.getAttribute( 'data-foto' );
        } );
      }, 250 );
    }

    pane.forEach( function ( p ) {
      var a = p.querySelector( '[data-mm="anteprima"]' );
      if ( ! a ) { return; }
      Array.prototype.forEach.call( p.querySelectorAll( '[data-mm="riga"]' ), function ( r ) {
        function scegli() {
          if ( stretto() ) { return; }
          var conto = r.getAttribute( 'data-conto' );
          var testo = conto && parseInt( conto, 10 ) > 0 ? numero( conto ) + ' ' + parolaPezzi : '';
          impostaAnteprima( a, r.getAttribute( 'data-nome' ), testo, r.getAttribute( 'data-foto' ), r.getAttribute( 'href' ), false );
        }
        r.addEventListener( 'mouseenter', scegli );
        r.addEventListener( 'focus', scegli );
      } );
    } );

    /* ── cambio di reparto ───────────────────────────────────────────────────────────── */

    /**
     * Mostra il reparto `id`. Da computer, se un altro reparto era gia' visibile, il cambio
     * e' animato: il vecchio esce di lato, il nuovo entra dall'altro lato, e la scheda
     * scivola alla nuova posizione con la nuova misura.
     */
    function mostra( id, subito ) {
      var prima = corrente;
      corrente = id;
      segna( id );
      var nuovo = paneDi( id );
      if ( ! nuovo ) { return; }
      clearTimeout( tCambio );

      var vecchio = prima && prima !== id ? paneDi( prima ) : null;
      var animato = ! subito && vecchio && ! vecchio.hidden && ! stretto() && ! ridotta();

      pane.forEach( function ( p ) {
        if ( p !== nuovo && p !== vecchio ) {
          p.hidden = true;
          p.removeAttribute( 'data-entra' );
          p.removeAttribute( 'data-esce' );
        }
      } );

      if ( ! animato ) {
        if ( vecchio ) { vecchio.hidden = true; vecchio.removeAttribute( 'data-esce' ); }
        nuovo.removeAttribute( 'data-entra' );
        nuovo.removeAttribute( 'data-esce' );
        nuovo.hidden = false;
        ripristinaAnteprima( nuovo );
        precarica( nuovo );
        posiziona( id );
        return;
      }

      var dir = ordine.indexOf( id ) > ordine.indexOf( prima ) ? 'dx' : 'sx';
      nuovo.removeAttribute( 'data-esce' );
      nuovo.setAttribute( 'data-entra', dir );
      nuovo.hidden = false;
      ripristinaAnteprima( nuovo );
      precarica( nuovo );
      // ⚠️ Un accesso alla misura obbliga il browser a disegnare lo stato di partenza:
      //    senza, toglierebbe `data-entra` prima di averlo mai applicato e non ci sarebbe
      //    nessuna transizione.
      void nuovo.offsetWidth;
      posiziona( id );
      vecchio.removeAttribute( 'data-entra' );
      vecchio.setAttribute( 'data-esce', dir );
      // ⚠️ `setTimeout`, non `requestAnimationFrame`: in una scheda del browser in secondo piano i
      //    fotogrammi non arrivano e il contenuto resterebbe invisibile finche' non si torna sopra.
      setTimeout( function () { nuovo.removeAttribute( 'data-entra' ); }, 20 );
      tCambio = setTimeout( function () {
        vecchio.hidden = true;
        vecchio.removeAttribute( 'data-esce' );
      }, DURATA_CAMBIO );
    }

    function apri( id ) {
      clearTimeout( tChiude );
      clearTimeout( tEsce );
      id = id || corrente || ordine[ 0 ];
      var era = aperto;
      aperto = true;
      if ( ! era ) {
        // ⚠️ Se stava ancora sfumando via, si riprende da li': niente salto.
        var inUscita = pannello.getAttribute( 'data-stato' ) === 'esce';
        pannello.hidden = false;
        if ( ! inUscita ) { pannello.setAttribute( 'data-stato', 'entra' ); }
        radice.setAttribute( 'data-aperto', '1' );
        mostra( id, true );
        void pannello.offsetWidth;
        setTimeout( function () { pannello.removeAttribute( 'data-stato' ); }, 20 );
        if ( velo ) { velo.hidden = stretto(); }
        if ( tutte ) { tutte.setAttribute( 'aria-expanded', 'true' ); }
        // ⚠️ Aprendo dal telefono si parte SEMPRE dall'elenco dei reparti: e' la mappa.
        passo( stretto() ? 1 : 0 );
        if ( stretto() ) { document.documentElement.style.overflow = 'hidden'; }
      } else {
        mostra( id, false );
      }
      segna( id );
    }

    function chiudi() {
      clearTimeout( tApre );
      if ( ! aperto ) { return; }
      aperto = false;
      radice.removeAttribute( 'data-aperto' );
      if ( velo ) { velo.hidden = true; }
      if ( tutte ) { tutte.setAttribute( 'aria-expanded', 'false' ); }
      voci.forEach( function ( v ) { v.setAttribute( 'aria-expanded', 'false' ); } );
      document.documentElement.style.overflow = '';
      if ( stretto() || ridotta() ) {
        pannello.hidden = true;
        pannello.removeAttribute( 'data-stato' );
        return;
      }
      pannello.setAttribute( 'data-stato', 'esce' );
      clearTimeout( tEsce );
      tEsce = setTimeout( function () {
        pannello.hidden = true;
        pannello.removeAttribute( 'data-stato' );
      }, DURATA_CHIUSURA );
    }

    /* ── la barra ────────────────────────────────────────────────────────────────────── */

    voci.forEach( function ( v ) {
      var id = v.getAttribute( 'data-gruppo' );
      v.addEventListener( 'click', function () {
        // ⛔ Col mouse la tendina e' GIA' aperta quando si arriva a cliccare: se il clic
        //    facesse da interruttore, cliccare il reparto lo CHIUDEREBBE. Il clic porta
        //    alla pagina del reparto; l'interruttore resta dove il passaggio del mouse non
        //    esiste (telefono) o e' spento.
        var dove = v.getAttribute( 'data-link' );
        if ( alPassaggio() && dove ) {
          window.location.href = dove;
          return;
        }
        if ( aperto && corrente === id ) { chiudi(); } else { apri( id ); }
      } );
      v.addEventListener( 'mouseenter', function () {
        if ( ! alPassaggio() ) { return; }
        clearTimeout( tChiude );
        clearTimeout( tApre );
        tApre = setTimeout( function () { apri( id ); }, aperto ? 0 : RITARDO_APRE );
      } );
      v.addEventListener( 'focus', function () {
        if ( ! stretto() && aperto ) { apri( id ); }
      } );
    } );

    if ( tutte ) {
      tutte.addEventListener( 'click', function () {
        if ( aperto ) { chiudi(); } else { apri( ordine[ 0 ] ); }
      } );
    }

    reparti.forEach( function ( r ) {
      var id = r.getAttribute( 'data-gruppo' );
      r.addEventListener( 'click', function () {
        mostra( id, true );
        if ( stretto() ) { passo( 2 ); }
      } );
    } );

    chiudiBt.forEach( function ( b ) { b.addEventListener( 'click', chiudi ); } );
    if ( indietro ) { indietro.addEventListener( 'click', function () { passo( 1 ); } ); }
    if ( velo ) { velo.addEventListener( 'click', chiudi ); }

    /* ── chiusura: basta allontanarsi ────────────────────────────────────────────────── */

    // ⛔ NON basta `mouseleave` sul contenitore: la scheda passa sopra ad altri elementi
    //    che si prendono il puntatore. Qui si guarda DOVE si trova il puntatore ad ogni
    //    spostamento: se non e' piu' dentro al menu, si chiude (dopo un attimo di grazia,
    //    che basta ad attraversare lo spazio fra la barra e la scheda).
    function dentro( el ) {
      if ( ! el ) { return false; }
      if ( velo && ( el === velo || velo.contains( el ) ) ) { return false; }
      return radice.contains( el );
    }

    function seguiIlMouse( e ) {
      if ( ! aperto ) { return; }
      if ( dentro( e.target ) ) {
        clearTimeout( tChiude );
        return;
      }
      if ( ! alPassaggio() ) { return; }
      clearTimeout( tApre );
      clearTimeout( tChiude );
      tChiude = setTimeout( chiudi, RITARDO_CHIUDE );
    }
    document.addEventListener( 'mouseover', seguiIlMouse );
    // ⚠️ Uscire dalla finestra dall'alto o di lato non genera `mouseover`: serve anche questo.
    document.addEventListener( 'mouseleave', function () {
      if ( aperto && alPassaggio() ) {
        tChiude = setTimeout( chiudi, RITARDO_CHIUDE );
      }
    } );
    radice.addEventListener( 'mouseenter', function () { clearTimeout( tChiude ); } );
    if ( velo ) {
      velo.addEventListener( 'mouseenter', function () {
        if ( alPassaggio() ) { chiudi(); }
      } );
    }

    // ⚠️ Scorrendo la pagina la tendina si chiude: chi scorre vuole vedere la pagina, e la
    //    scheda resterebbe a mezz'aria staccata dalla sua voce.
    window.addEventListener( 'scroll', function () {
      if ( aperto && ! stretto() ) { chiudi(); }
    }, { passive: true } );
    window.addEventListener( 'resize', function () {
      if ( ! aperto ) { return; }
      if ( stretto() ) { posiziona( corrente ); } else { posiziona( corrente ); }
    } );

    document.addEventListener( 'keydown', function ( e ) {
      if ( e.key === 'Escape' && aperto ) { chiudi(); }
    } );
    // ⚠️ Un clic fuori chiude anche senza velo (sul telefono il velo non c'e').
    document.addEventListener( 'click', function ( e ) {
      if ( aperto && ! radice.contains( e.target ) ) { chiudi(); }
    }, true );
    // ⚠️ Se si esce col tasto TAB dalla scheda, il menu deve chiudersi da solo.
    radice.addEventListener( 'focusout', function ( e ) {
      if ( aperto && ! stretto() && ! radice.contains( e.relatedTarget ) ) { chiudi(); }
    } );

    corrente = ordine[ 0 ];
    segna( corrente );

    /**
     * ⛔ DUE MENU DIVERSI SUL TELEFONO. Il pulsante ☰ del tema apriva il SUO cassetto, con
     * il vecchio elenco, mentre la barra apriva il nostro. Qui il ☰ apre questo, che e'
     * l'unico aggiornato.
     * ⚠️ Si intercetta in fase di CATTURA e si ferma li': il cassetto del tema non deve
     *    nemmeno cominciare ad aprirsi, altrimenti restano due pannelli sovrapposti.
     */
    if ( radice.getAttribute( 'data-hamburger' ) !== 'false' ) {
      document.addEventListener( 'click', function ( e ) {
        if ( ! stretto() ) { return; }
        var b = e.target.closest && e.target.closest(
          '.head-slot-nav-mobile-link, .button-main-nav-toggle, [class*="nav-mobile-link"]' );
        if ( ! b || radice.contains( b ) ) { return; }
        e.preventDefault();
        e.stopPropagation();
        apri( corrente || ordine[ 0 ] );
      }, true );
    }
  }

  function tutteLeRadici() {
    document.querySelectorAll( '[data-ntc-megamenu]' ).forEach( avvia );
  }
  if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', tutteLeRadici );
  } else { tutteLeRadici(); }
  document.addEventListener( 'shopify:section:load', tutteLeRadici );
}() );
